/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1LocationStatesQueryResponse,
  GetApiV1LocationStates401,
  GetApiV1LocationStates500,
} from "../../types/locationStateController/GetApiV1LocationStates.ts";

function getGetApiV1LocationStatesUrl() {
  const res = { method: "GET", url: `/api/v1/location/states` as const };
  return res;
}

/**
 * @description Retorna todos os estados cadastrados com o nome do país, ordenados por nome. **(Requer Authorization para autenticação)**
 * @summary Listar estados (Requer Authorization para autenticação)
 * {@link /api/v1/location/states}
 */
export async function getApiV1LocationStates(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1LocationStatesQueryResponse,
    ResponseErrorConfig<GetApiV1LocationStates401 | GetApiV1LocationStates500>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1LocationStatesUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
